import React from 'react';
import { Link } from 'react-router';

let logoImg = require('assets/images/logo.png');

export default class Logo extends React.Component {
  render() {
    const userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    const TTTW = 19;
    return (
      <div className="logo-wrap">
        <h1 className="logo" id="logo">
          <Link to={userInfo.capCoQuanQuanLyId !== TTTW ? '/' : '/thanh-tra'} className="logo-link">
            <img src={logoImg} alt="" className="logo-image" />
          </Link>
        </h1>
        <div className="logo-text">Phần mềm và xây dựng cơ sở dữ liệu hoạt động thanh tra trên địa bàn Tỉnh Quảng Ngãi</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/layout/partials/Logo.jsx